import CommentItem from "./commentItem.component";

export default CommentItem;
